export const SET_WORKSPACE_INFORMATION_LOADING = "onboarding/workspace/loading";
export const SET_WORKSPACE_INFORMATION_SUCCESS = "onboarding/workspace/success";
export const SET_WORKSPACE_INFORMATION_ERROR = "onboarding/workspace/error";

export const SET_CREATE_WORKSPACE_LOADING = "workspace/create/loading";
export const SET_CREATE_WORKSPACE_SUCCESS = "workspace/create/success";
export const SET_CREATE_WORKSPACE_ERROR = "workspace/create/error";
